import * as React from "react";

const SvgDom = ({ rackColor = "#001D3D" , ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="344"
    height="226.05"
    fill="none"
    viewBox="0 0 140 92"
    {...props}
  >
  <path
      fill="none"
      stroke="black"
      strokeWidth="10"
      d="M135 87H5V37.473l2.847-1.358 60-28.628L70 6.46l2.153 1.027 60 28.628L135 37.473z"
    />
    <path
      fill="#D7EAFF"
      stroke={rackColor}
      strokeWidth="9"
      d="M135 87H5V37.473l2.847-1.358 60-28.628L70 6.46l2.153 1.027 60 28.628L135 37.473z"
    ></path>
    
  </svg>
);

export default SvgDom;
